<template>
    <vue-typer 
        id="typewriter"
        :repeat='0' 
        :type-delay='5'
        :text="text"
        :preTypeDelay="1000"
        @typed="$emit('typed')"
        @typed-char="onTypedChar"
        >
    </vue-typer>
</template>
<script>

export default {
  props: ['typed','text'],
  data: () => ({
    countWord: 0,
  }),
  methods: {
      onTypedChar: function (typedChar, typedCharIndex) {
          if (typedCharIndex == 0) {
              document.getElementById('typewriter').firstChild.innerHTML = '';
          }
          var lessNodes = document.getElementById('typewriter').lastChild.childNodes;
          if (typedChar == " " || lessNodes.length == 1) {

              var finalNodes = document.getElementById('typewriter').firstChild;
              var listNodes = finalNodes.childNodes;

              var newNode = document.createElement('span');

              var x = this.countWord;
              var countNodes = listNodes.length;
              while (x < countNodes) {
                  if (listNodes[this.countWord].innerHTML != " ")
                      newNode.insertAdjacentElement('beforeend', listNodes[this.countWord]);
                  else
                      this.countWord++;

                  // TODO: ADD LAST CHAR
                  x++;
              }
              newNode.className = 'nowrap';
              finalNodes.insertAdjacentElement('beforeend', newNode);

              this.countWord++;
          }
      },
  }
};

</script>
<style>
span.nowrap{
 white-space: nowrap;
}</style>